// 导入图片
import image__breaker from "../imgs/breaker.png"
import image__bus from "../imgs/bus.png"
import image__chargePile from "../imgs/chargePile.png"
import image__circle from "../imgs/circle.png"
import image__eBlock from "../imgs/eBlock.png"
import image__eLink from "../imgs/eLink.png"
import image__ess from "../imgs/ess.png"
import image__essLib from "../imgs/ess-lib.png"
import image__flyLine from "../imgs/fly-line.png"
import image__ground from "../imgs/ground.png"
import image__payload from "../imgs/payload.png"
import image__pcc from "../imgs/pcc.png"
import image__pcs from "../imgs/pcs.png"
import image__pv from "../imgs/pv.png"
import image__pvLib from "../imgs/pv-lib.png"
import image__rect from "../imgs/rect.png"
import image__square from "../imgs/square.png"
import image__text from "../imgs/text.png"
import image__tfmNormal from "../imgs/tfm-normal.png"
import image__tfmOverload from "../imgs/tfm-overload.png"
import image__transformer from "../imgs/transformer.png"
import image__foldLine from "../imgs/fold-line.png"

const imageUrls = {
  image__breaker,
  image__bus,
  image__chargePile,
  image__circle,
  image__eBlock,
  image__eLink,
  image__ess,
  image__essLib,
  image__flyLine,
  image__ground,
  image__payload,
  image__pcc,
  image__pcs,
  image__pv,
  image__pvLib,
  image__rect,
  image__square,
  image__text,
  image__tfmNormal,
  image__tfmOverload,
  image__transformer,
  image__foldLine,
}


const nameAlias = {
  /** 业务类型名与资源文件名不一致时在此映射 */
  chargeStation: 'chargePile',
}

export function getImgSrcByName(name) {
  const key = nameAlias[name] || name
  return imageUrls[`image__${key}`]
}
